import React from "react";
import Header from "../../../../Components/Header";
import {Helmet} from "react-helmet";
import MainContent from "./MainContent";

function MainList() {

    return (
        <div>
            <Helmet>
               <title>Quality Inspection List</title>

            </Helmet>
            
            <Header />

            <MainContent />
            
        </div>
    )
}
export default MainList